import { useNavigate } from 'react-router-dom';

import { TSLErrorScreen } from '@thirdspacelearning/library';

import { RoutePaths } from '@routes';

const NoMatch = () => {
    const navigate = useNavigate();

    const backToHome = () => {
        navigate(RoutePaths.DASHBOARD);
    };

    return (
        <TSLErrorScreen
            title="Uh oh - it looks like you’re in the wrong place"
            lines={[]}
            onTryAgain={backToHome}
        />
    );
};

export default NoMatch;
